<template>
  <div v-if="!text" v-bind="$attrs">
    <slot></slot>
  </div>
  <a-tooltip v-else-if="badgeMps?.length" placement="top">
    <template #title>
      {{
        "Внимание! В данном товаре имеются изменения, которые не выгружались на: " +
        marketplaces
      }}
    </template>
    <div class="badge-wrapper" v-bind="$attrs">
      <slot></slot>
      <span
        class="custom-badge"
        :style="{
          top: positionX,
          right: positionY,
          backgroundColor,
          color: textColor,
          width: size,
          height: size,
          fontSize,
        }"
      >
        {{ text }}
      </span>
    </div>
  </a-tooltip>
  <div v-else class="badge-wrapper" v-bind="$attrs">
    <slot></slot>
    <span
      class="custom-badge"
      :style="{
        top: positionX,
        right: positionY,
        backgroundColor,
        color: textColor,
        width: size,
        height: size,
        fontSize,
      }"
    >
      {{ text }}
    </span>
  </div>
</template>

<script setup lang="ts">
import {
  MarketPlacesEnum,
  type MarketPlacesEnum as MarketPlacesEnumType,
} from "@/types/types";
import { computed } from "vue";

interface BadgeProps {
  text: string | null;
  positionX?: string;
  positionY?: string;
  backgroundColor?: string;
  textColor?: string;
  size?: string;
  fontSize?: string;
  badgeMps?: MarketPlacesEnumType[];
}

const props = withDefaults(defineProps<BadgeProps>(), {
  positionX: "-5px",
  positionY: "-5px",
  backgroundColor: "#FF5226",
  textColor: "#FFFFFF",
  size: "21px",
  fontSize: "12px",
  badgeMps: () => [],
});

defineOptions({
  inheritAttrs: false,
});

const marketplaces = computed(() => {
  return (
    props.badgeMps
      ?.map((mp) => {
        switch (mp) {
          case MarketPlacesEnum.wildberries:
            return "Wildberries";
          case MarketPlacesEnum.ozon:
            return "Ozon";
          case MarketPlacesEnum.yandexMarket:
            return "Яндекс Маркет";
        }
      })
      ?.join(", ") || ""
  );
});
</script>

<style scoped lang="scss">
.badge-wrapper {
  position: relative;
  display: inline-block;

  .custom-badge {
    position: absolute;
    padding: 0;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
  }
}
</style>
